import React from "react";
import { useForm } from "react-hook-form";
import {
  Button,
  Grid,
  ReactSelectController,
} from "@pushpress/shared-components";
import {
  AttendanceStatusOption,
  attendanceStatusOptions,
} from "./AttendanceReport.utils";
import { SubscriptionFilterOptionFragment } from "./Attendance-generated.hooks";

export interface AttendanceFilterValue {
  subscriptions?: SubscriptionFilterOptionFragment[];
  status?: AttendanceStatusOption[];
}

interface AttendanceFilterProps {
  filter: AttendanceFilterValue;
  subscriptions?: SubscriptionFilterOptionFragment[];
  onFilterChange: (filter: AttendanceFilterValue) => void;
  onClear: VoidFunction;
}

const AttendanceFilter = (props: AttendanceFilterProps) => {
  const { filter, subscriptions, onFilterChange, onClear } = props;

  const { control, handleSubmit } = useForm<AttendanceFilterValue>({
    mode: "onTouched",
    defaultValues: filter,
  });

  return (
    <form
      className="p-3"
      style={{ width: 300 }}
      onSubmit={handleSubmit(onFilterChange)}
    >
      <ReactSelectController
        control={control}
        name="status"
        label="Status"
        options={attendanceStatusOptions}
        isMulti
        isClearable
        hideDropdownIndicator
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
      />
      <ReactSelectController
        options={subscriptions}
        control={control}
        name="subscriptions"
        label="Plan"
        isMulti
        isClearable
        hideDropdownIndicator
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        getOptionValue={(item) => item.subscriptionUuid}
        getOptionLabel={(item) => item.planObject.name}
      />
      <Grid container justifyContent="flex-end">
        <Grid item>
          <Button
            buttonType="secondary"
            type="button"
            text="Clear"
            onClick={onClear}
          />
        </Grid>
        <Grid item>
          <Button buttonType="primary" type="submit" text="Apply" />
        </Grid>
      </Grid>
    </form>
  );
};

export default AttendanceFilter;
